import { MutationUpdaterFn } from '@apollo/client'
import {
  ChannelChildCommentsDocument,
  ChannelChildCommentsQuery,
  GqlCreateNewsCommentMutation,
  NewsItemFooter_NewsItemFragment,
  NewsItemFooter_NewsItemFragmentDoc,
} from 'generated/graphql'

const createNewsChildCommentUpdater =
  (
    newsItemId: string,
    parentId: string,
  ): MutationUpdaterFn<GqlCreateNewsCommentMutation> =>
  (cache, mutationResult) => {
    const variables = {
      newsItemId,
      parentId,
      commentFirst: 1,
      commentAfter: undefined,
    }
    const cachedComments = cache.readQuery<ChannelChildCommentsQuery>({
      query: ChannelChildCommentsDocument,
      variables,
    })

    if (
      !mutationResult.data ||
      !mutationResult.data.createNewsComment.newsComment
    )
      return
    const createdComment = {
      cursor: '',
      node: mutationResult.data.createNewsComment.newsComment,
      __typename: 'NewsCommentEdge',
    }

    if (!cachedComments || !cachedComments?.comments.edges) return

    cache.writeQuery({
      query: ChannelChildCommentsDocument,
      variables,
      data: {
        ...cachedComments,
        comments: {
          ...cachedComments?.comments,
          edges: [createdComment, ...cachedComments.comments.edges],
        },
      },
    })

    const targetFragmentOptions = {
      id: `NewsItem:${newsItemId}`,
      fragment: NewsItemFooter_NewsItemFragmentDoc,
      fragmentName: 'NewsItemFooter_NewsItem',
    }

    const cachedNewsItem = cache.readFragment<NewsItemFooter_NewsItemFragment>({
      ...targetFragmentOptions,
    })

    if (cachedNewsItem) {
      cache.writeFragment<NewsItemFooter_NewsItemFragment>({
        ...targetFragmentOptions,
        data: {
          ...cachedNewsItem,
          newsCommentCount: cachedNewsItem.newsCommentCount + 1,
        },
      })
    }
  }

export default createNewsChildCommentUpdater
